import { MessageSquare } from 'lucide-react';

/**
 * The Comments section: a placeholder, and ONLY a placeholder.
 *
 * ⚠️ The design's screenshot shows a disabled composer at the bottom of this panel. It is a picture of a
 * future state and is deliberately NOT built — there is no comments endpoint, no state, and no request. The
 * handoff says so in as many words, and a disabled input that will never enable is a promise the app cannot
 * keep.
 *
 * Copy is verbatim from the handoff §6.
 */
export function CommentsComingSoon() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
      <span
        aria-hidden
        className="flex h-[42px] w-[42px] items-center justify-center rounded-xl bg-info/10 text-info"
      >
        <MessageSquare className="h-5 w-5" />
      </span>

      <h3 className="text-[13.5px] font-semibold text-foreground">Comments are coming soon</h3>

      <p className="max-w-[250px] text-xs leading-relaxed text-muted-foreground">
        Threaded discussion with @mentions, in the same panel as the audit trail — so the reason sits next to
        the event that caused it.
      </p>
    </div>
  );
}
